export default theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap'
  }
})
